// Inline SVG flags instead of Unicode flag emoji — regional-indicator emoji
// sequences (🇩🇪 etc.) render as a colored flag only if the OS/browser ships a
// color-emoji font (e.g. Noto Color Emoji). Without one (common on minimal
// Linux desktops, and historically on Windows) they fall back to plain
// two-letter glyphs, which looks like leftover text instead of an icon. SVG
// renders identically everywhere.
const FLAG_ICON_BODY = {
  DE: '<rect width="30" height="20" fill="#000000" stroke="none"/><rect y="6.67" width="30" height="6.67" fill="#DD0000" stroke="none"/><rect y="13.33" width="30" height="6.67" fill="#FFCE00" stroke="none"/>',
  FR: '<rect width="30" height="20" fill="#0055A4" stroke="none"/><rect x="10" width="10" height="20" fill="#FFFFFF" stroke="none"/><rect x="20" width="10" height="20" fill="#EF4135" stroke="none"/>',
  IT: '<rect width="30" height="20" fill="#008C45" stroke="none"/><rect x="10" width="10" height="20" fill="#F4F5F0" stroke="none"/><rect x="20" width="10" height="20" fill="#CD212A" stroke="none"/>',
  EN: '<rect width="30" height="20" fill="#00247D" stroke="none"/>'
    + '<path d="M0,0 L30,20 M30,0 L0,20" stroke="#FFFFFF" stroke-width="4.4" fill="none"/>'
    + '<path d="M0,0 L30,20 M30,0 L0,20" stroke="#CF142B" stroke-width="1.8" fill="none"/>'
    + '<path d="M15,0 V20 M0,10 H30" stroke="#FFFFFF" stroke-width="7" fill="none"/>'
    + '<path d="M15,0 V20 M0,10 H30" stroke="#CF142B" stroke-width="4.2" fill="none"/>'
};

// Falls back to '' (caller then shows flagge_emoji/sprache_code text) for any
// language code added later via the Sprachen-Admin that isn't one of the four
// shipped here — keeps the admin's free-text language codes from breaking.
export function flagIconSvg(sprachCode) {
  const body = FLAG_ICON_BODY[String(sprachCode || '').trim().toUpperCase()];
  if (!body) return '';
  return `<svg class="flag-icon" viewBox="0 0 30 20" aria-hidden="true" focusable="false">${body}</svg>`;
}
